module.exports = __webpack_public_path__ + "static/media/2460467 receivership-appointment-order-dated-aug-7-2024.3ae468f6.pdf";